"use client";

import { SearchParams } from "@/constants/common";
import React from "react";
import { useSearchParams } from "next/navigation";
import EventDetails from "@/src/components/Events/EventDetails";
import PublicEvents from "@/src/components/Events/PublicEvents";

const PublicEventsLayout: React.FC = () => {
  const searchParams = useSearchParams();
  const id = searchParams.get(SearchParams.id);

  return id ? <EventDetails id={id} /> : <PublicEvents />;
};

export default PublicEventsLayout;
